import ReadMoreButton from "./ReadMoreButton";

const LoginButton = () => {
    return (
        <div className="flex items-center">
            <ReadMoreButton></ReadMoreButton>
            <a
                href="#"
                className="ml-8 whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700"
            >
                Sign up
            </a>
        </div>
    )
} 

export default LoginButton;